import React from "react";
import { Layout } from "Components/Layout/Layout";
import { Footer } from "Components/Footer/Footer";
import { StatCard } from "Components/StatCard/StatCard";
import { StarIcon } from "Components/Icons/Miscellaneous/StarIcon";
import { PartyPopperIcon } from "Components/Icons/Miscellaneous/PartyPopperIcon";
import { FileCertificateIcon } from "Components/Icons/Documents/FileCertificateIcon";
import { CertificateIcon } from "Components/Icons/Documents/CertificateIcon";
import { UserForm } from "Forms/UserForm/UserForm";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";
import { useQuery } from "Hooks/useQuery";
import {
  getUsuarioEstadisticas,
  getUsuarioPerfil,
} from "Services/usuario_service";
import { StatCardSkeleton } from "Components/StatCardSkeleton/StatCardSkeleton";
import { useNavigate } from "react-router-dom";
import { RUTAS } from "rutas";
import "./Usuario.scss";

export const Usuario = () => {
  const { authUser } = useSelector((state) => state.auth);
  const isAuthenticated = Boolean(authUser.token);
  const idUsuario = authUser.idUsuario;
  const navigate = useNavigate();

  const { data: estadisticasData, isLoading: estadisticasLoading } = useQuery(
    getUsuarioEstadisticas,
    { idUsuario },
    isAuthenticated
  );

  const { data: perfilData, isLoading: perfilLoading } = useQuery(
    getUsuarioPerfil,
    { idUsuario },
    isAuthenticated
  );

  const getInitials = (name) => {
    if (!name) return "U";

    const words = name.trim().split(/\s+/);
    const firstLetter = words[0].charAt(0).toUpperCase();
    const lastLetter = words[words.length - 1].charAt(0).toUpperCase();

    return firstLetter + lastLetter;
  };

  const to2D = (num) => {
    if (num == null) return "00";
    return num.toString().padStart(2, "0");
  };

  return (
    <Layout>
      <div className="usuario">
        <div className="usuario__breadcrumb">
          <h1 className="usuario__breadcrumb-title">Usuario</h1>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => {
                navigate(RUTAS.PRINCIPAL);
              }}
            >
              Inicio
            </Link>
            <Typography>Mi Usuario</Typography>
          </Breadcrumbs>
        </div>
        <div className="usuario__statistics">
          {!estadisticasLoading && (
            <>
              <StatCard
                icon={<StarIcon />}
                title="Cursos asignados"
                count={to2D(estadisticasData?.cursosAsignados)}
              />
              <StatCard
                icon={<PartyPopperIcon />}
                title="Cursos completados"
                count={to2D(estadisticasData?.cursosCompletados)}
              />
              <StatCard
                icon={<FileCertificateIcon />}
                title="Paquetes asignados"
                count={to2D(estadisticasData?.paquetesAsignados)}
              />
              <StatCard
                icon={<CertificateIcon />}
                title="Paquetes completados"
                count={to2D(estadisticasData?.paquetesCompletados)}
              />
            </>
          )}

          {estadisticasLoading &&
            Array.from({ length: 4 }).map((_, index) => (
              <StatCardSkeleton key={index} />
            ))}
        </div>
        <div className="usuario__profile">
          <div className="usuario__profile-header">
            <h2 className="usuario__profile-title">
              {perfilLoading && <Skeleton variant="text" />}
              {!perfilLoading &&
                `${perfilData?.nombreCompleto || "Nombre no disponible"}`}
            </h2>
            <p className="usuario__profile-subtitle">
              {perfilLoading && <Skeleton variant="text" />}
              {!perfilLoading &&
                `Usuario desde ${perfilData?.usuarioDesde || "00/00/0000"}`}
            </p>
          </div>
          <div className="usuario__profile-image">
            {perfilData?.foto ? (
              <img
                src={perfilData.foto}
                alt="User profile"
                className="usuario__profile-image-user"
              />
            ) : (
              <div className="usuario__profile-image-placeholder">
                {getInitials(perfilData?.nombreCompleto)}
              </div>
            )}
          </div>
        </div>
        <UserForm
          className="usuario__form"
          perfilData={perfilData}
          idUsuario={idUsuario}
          perfilLoading={perfilLoading}
        />
      </div>
      <Footer />
    </Layout>
  );
};
